/** The colours went with the diagram, so the contrast lives in the words. */
const key = [
  ['Without arbitration', 'Both fleets stop safely, neither yields, and the aisle stays shut until somebody walks over.'],
  ['With arbitration', 'One fleet holds the shared span. The other waits clear of the travel lane.'],
  ['The handover', 'The holder gives the span back once it is clear of it. Waiting fleets cannot demand it.'],
  ['What it costs', 'A blocked aisle stops both fleets, not only the one that arrived second.'],
] as const;

export function SharedFloor() {
  return (
    <section className="sec sec--dark" id="aisle">
      <div className="sec__label">Shared floor</div>
      <h2 className="big drift drift--rev">Two fleets.<br />One aisle.</h2>

      <div className="visual-key">
        {key.map(([name, what]) => (
          <div className="reveal" key={name}><b>{name}</b><span>{what}</span></div>
        ))}
      </div>

      <p className="visual-caption reveal">
        Two vehicles meeting nose to nose in a single-width aisle are both behaving correctly,
        and that is the difficulty. <b>Correct behaviour on both sides still leaves the aisle
        shut, because neither fleet can grant the other priority.</b>
      </p>
    </section>
  );
}
